module.exports = __webpack_public_path__ + "static/media/S2N5-1.4f893bde.svg";